module.exports = __webpack_public_path__ + "img/ColouredGel-Headshot.8d544ae3.jpeg";